import { css } from '@emotion/core'
import tw from 'tailwind.macro'

export const layoutStyles = css`
  ${tw`
    relative
    w-full
    overflow-x-hidden
  `};
`